import React from "react";
import Pep from "./features/pep/Pep";

function App() {
  return <Pep />;
}

export default App;
